import React, { Component } from 'react';

class Spinner extends Component {
  render() {
    return (
      <div className="la-ball-clip-rotate-pulse">
        <div></div>
        <div></div>
      </div>
    );
  }
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner.js